import { Component, HostBinding, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '@services/admin/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'register-box';

  public registerForm: UntypedFormGroup;
  public isAuthLoading = false;

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: UserService,
  ) {}

  ngOnInit() {
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      this.renderer.addClass(appRoot, 'register-page');
    }
    this.registerForm = new UntypedFormGroup({
      email: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, [Validators.required]),
      retypePassword: new UntypedFormControl(null, [Validators.required]),
    });
  }

  async registerByAuth() {
    if (this.registerForm.valid) {
      this.isAuthLoading = true;
      await this.appService.registerByAuth(this.registerForm.value);
      this.isAuthLoading = false;
    } else {
      this.toastr.error('Form is not valid!');
    }
  }

  ngOnDestroy() {
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      this.renderer.removeClass(appRoot, 'register-page');
    }
  }
}
